import EuroIcon from '@mui/icons-material/Euro';
import PaymentsIcon from '@mui/icons-material/Payments';
import PersonOffIcon from '@mui/icons-material/PersonOff';

export type PainAccount = {
  iban: string;
  name: string;
  description: string;
  icon: React.ReactNode;
};

// Hardcoded for now; will move to a backend source when the accounts change.
export const PAIN_ACCOUNTS: PainAccount[] = [
  {
    iban: 'BE76973351417795',
    name: 'Dividend',
    description: 'Dividend payouts',
    icon: <EuroIcon />
  },
  {
    iban: 'BE87973351417694',
    name: 'Exit',
    description: 'Exit repayments & uitschrijvingen',
    icon: <PersonOffIcon />
  },
  {
    iban: 'BE84973171450059',
    name: 'Repayments',
    description: 'Payment refunds',
    icon: <PaymentsIcon />
  }
];
